import Component from 'classes/Component'
import GSAP from 'gsap'

export default class Header extends Component {
  constructor() {
    super({
      element: '.header',
      elements: {
        nav: document.querySelector('.menu'),
        logo: '.logo',
        menu: '.menu_button',
        lang: '.lang_selector',
        reserve: '.reserve_button'
      }
    })

    this.elements.all = [
      this.elements.logo,
      this.elements.lang,
      this.elements.reserve
    ]

    this.tl = GSAP.timeline()

    this.createInteractions()
  }

  scrollDown = () => {
    this.element.classList.remove('visible')
    this.element.classList.add('hidden')

    this.tl.to(this.elements.all, {
      autoAlpha: 0,
      y: '-8rem',
      duration: 0.25,
      ease: 'power4.out',
      stagger: {
        axis: 'x',
        amount: 0.35
      }
    })

    this.element.addEventListener('mouseenter', this.showHeader)
    this.element.addEventListener('mouseleave', this.hideHeader)

    if (this.elements.nav.classList.contains('menu_visible')) {
      this.element.removeEventListener('mouseleave', this.hideHeader)
    }
  }

  hideHeader = () => {
    this.element.classList.remove('visible')
    this.element.classList.add('hidden')

    this.tl.to(this.elements.all, {
      autoAlpha: 0,
      y: '-8rem',
      duration: 0.15,
      ease: 'power4.out',
      stagger: {
        axis: 'x',
        amount: 0.35
      }
    })

    this.element.addEventListener('mouseenter', this.showHeader)
  }

  showHeader = () => {
    this.element.classList.remove('hidden')
    this.element.classList.add('visible')

    this.tl.clear()

    this.tl.to(this.elements.all, {
      y: 0,
      autoAlpha: 1,
      duration: 0.5,
      ease: 'power4.out',
      delay: 0.25
    }).restart()

    this.element.addEventListener('mouseleave', this.hideHeader)
  }

  scrollUp = () => {
    this.element.classList.add('visible')
    this.element.classList.remove('hidden')

    this.tl.clear()

    this.tl.to(this.elements.all, {
      y: 0,
      autoAlpha: 1,
      duration: 0.5,
      ease: 'power4.out',
      delay: 0.25
    })

    this.element.removeEventListener('mouseenter', this.showHeader)
    this.element.removeEventListener('mouseleave', this.hideHeader)
  }

  createInteractions = () => {
    this.elements.menu.addEventListener('click', this.deactivate)

  }

  deactivate = () => {
    setTimeout(() => {
      if (this.elements.nav.classList.contains('menu_visible')) {
        this.element.removeEventListener('mouseleave', this.hideHeader)
      }

    }, 25)
  }

  addEventListeners() {
    // window.addEventListener('scroll', this.checkScrollDirection.bind(this))
  }
}
